<template>
  <div>
    <div @mousemove="move" class="w3l-banner">
      <div :style="'transform: translate('+(position == 'left'?'20':'-20')+'px,' +(position2=='top'?'10':'-10')+'px) scale(1.1)'" class="banner-image"></div>
      <div class="titleBox" :class="contType == 'e' ? 'titleBoxe' : ''">
        <!-- <div class="wow flipInX titleT1" :class="[contType == 'e' ? 'titleT1e' : '', contType == 'e' ? 'mgt20e' : '']">{{ contList.title1[contType] }}</div>
        <div class="wow flipInX titleT1" :class="contType == 'e' ? 'titleT1e' : ''">{{ contList.title2[contType] }}</div> -->
        <div class="wow flipInX titleT1" :class="[contType == 'e' ? 'titleT1e' : '', contType == 'e' ? 'mgt20e' : '']">{{ contType == 'e' ? contList.title1[contType] + contList.title2[contType] : contList.title1[contType] + '\n' + contList.title2[contType] }}</div>
        <div class="wow flipInX" :class="contType == 'e' ? 'titleT11e' : 'titleT11'">{{ contType == 'e' ? contList.title1[contType] + contList.title2[contType] : contList.title1[contType] + '\n' + contList.title2[contType] }}</div>
        <div class="wow flipInX titleT2" :class="contType == 'e' ? 'titleT2e' : ''">{{ contList.title3[contType] }}</div>
        <div class="wow flipInX experience" @click="goContactUs">{{ contList.titleBtn[contType] }}</div>
        <img class="wow bounceInUp  titlebg" src="../assets/img/index/titlebg.png" alt="">
        <img class="wow bounceInRight titlebgIcon1" src="../assets/img/index/titleBGIcon1.png" alt="">
        <img class="wow bounceInRight titlebgIcon2" src="../assets/img/index/titleBGIcon2.png" alt="">
        <img class="wow bounceInRight titlebgIcon3" :class="contType == 'e' ? 'titlebgIcon3e' : ''" src="../assets/img/index/pop.png" alt="">

      </div>
    </div>
    <div class="bgBox">
      <img class="bg1" src="../assets/img/index/bg1.png" alt="">
      <img class="bg2" src="../assets/img/index/bg2.png" alt="">
      <img class="bg3" :class="contType == 'e' ? 'bg3e' : ''" src="../assets/img/index/bg5.png" alt="">
      <img class="bg4" :class="contType == 'e' ? 'bg4e' : ''" src="../assets/img/index/bg4.png" alt="">
    </div>

    <div class="contBox">
      <div class="wow bounceInUp generalTitle mt100" data-wow-duration="1s" >{{contList.general1T1[contType]}}</div>
      <div class="wow bounceInUp generalTitle2 pcHide" data-wow-duration="1s">{{contList.general1T2[contType]}}</div>
      <div class="wow bounceInUp generalTitle2 mb60 pcHide" data-wow-duration="1s">{{contList.general1T3[contType]}}</div>
      <div class="wow bounceInUp generalTitle2 mb60 phoneHide" data-wow-duration="1s">{{contList.general1T2[contType] + contList.general1T3[contType]}}</div>
      <div class="programme">
        <div :class="['wow', 'bounceInUp', 'programmeBox']" data-wow-delay="0.1s" @mouseenter="handleMouseEnter('0')" @mouseleave="handleMouseLeave('0')">
          <img v-if="hoverType[0] == 0" class="programmeIcon" src="../assets/img/index/icon_001.png" alt="">
          <img v-if="hoverType[0] == 1" class="programmeIcon" src="../assets/img/index/icon_0011.png" alt="">
          <div class="programmeT1">{{contList.programmeB1T1[contType]}}</div>
          <div class="programmeT2">{{contList.programmeB1T2[contType]}}</div>
        </div>
        <div class="wow bounceInUp programmeBox" data-wow-delay="0.2s" @mouseenter="handleMouseEnter('1')" @mouseleave="handleMouseLeave('1')">
          <img v-if="hoverType[1] == 0" class="programmeIcon" src="../assets/img/index/icon_002.png" alt="">
          <img v-if="hoverType[1] == 1" class="programmeIcon" src="../assets/img/index/icon_0022.png" alt="">
          <div class="programmeT1">{{contList.programmeB2T1[contType]}}</div>
          <div class="programmeT2">{{contList.programmeB2T2[contType]}}</div>
        </div>
        <div class="wow bounceInUp programmeBox" data-wow-delay="0.3s" @mouseenter="handleMouseEnter('2')" @mouseleave="handleMouseLeave('2')">
          <img v-if="hoverType[2] == 0" class="programmeIcon" src="../assets/img/index/icon_003.png" alt="">
          <img v-if="hoverType[2] == 1" class="programmeIcon" src="../assets/img/index/icon_0033.png" alt="">
          <div class="programmeT1">{{contList.programmeB3T1[contType]}}</div>
          <div class="programmeT2">{{contList.programmeB3T2[contType]}}</div>
        </div>
      </div>
      <div class="programme2">
        <div class="wow bounceInUp programme2L">
          <img class="programmeBG" src="../assets/img/index/programmeBG.png" alt="">
          <img class="point" src="../assets/img/index/point.png" alt="">
        </div>
        <div class="wow bounceInUp programme2R">
          <div class="programme2RBox">
            <div class="programme2RT1">{{contList.programme2T[contType][0]}}</div>
            <div class="programme2RT2" :class="contType != 'e' ? 'programme2RT2z' : ''">{{contList.programme2T[contType][1]}}</div>
          </div>
          <div class="wow bounceInUp programme2RBox">
            <div class="programme2RT1">{{contList.programme2T[contType][2]}}</div>
            <div class="programme2RT2" :class="contType != 'e' ? 'programme2RT2z' : ''">{{contList.programme2T[contType][3]}}</div>
          </div>
          <div class="wow bounceInUp programme2RBox">
            <div class="programme2RT1">{{contList.programme2T[contType][4]}}</div>
            <div class="programme2RT2" :class="contType != 'e' ? 'programme2RT2z' : ''">{{contList.programme2T[contType][5]}}</div>
          </div>
          <div class="wow bounceInUp programme2RBox">
            <div class="programme2RT1">{{contList.programme2T[contType][6]}}</div>
            <div class="programme2RT2" :class="contType != 'e' ? 'programme2RT2z' : ''">{{contList.programme2T[contType][7]}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="congBox2">
      <div class="contBox dpa">
        <div class="wow bounceInUp numBox mgt65">
          <div class="numBoxT1">
            <animate-number style="font-family: Oswald-Regular !important;" from="0" to="10"></animate-number>
            <div v-if="contType == 'e'" class="numBoxT1Ye">
              years
            </div>
            {{ contType != 'e' ? "年" : "" }}
            +
          </div>
          <div class="numBoxT2">{{contList.numBox[contType][1]}}</div>
        </div>
        <div class="wow bounceInUp numBox mgt65" data-wow-delay="0.1s">
          <div class="numBoxT1">
            <animate-number style="font-family: Oswald-Regular !important;" from="0" to="150"></animate-number>+</div>
          <div class="numBoxT2">{{contList.numBox[contType][3]}}</div>
        </div>
        <div class="wow bounceInUp numBox mgt-50" data-wow-delay="0.2s">
          <div class="numBoxT1">
            <animate-number style="font-family: Oswald-Regular !important;" from="0" to="20"></animate-number>+</div>
          <div class="numBoxT2">{{contList.numBox[contType][5]}}</div>
        </div>
        <div class="wow bounceInUp numBox mgt-50" data-wow-delay="0.3s">
          <div class="numBoxT1">
            <animate-number style="font-family: Oswald-Regular !important;" from="0" to="2000"></animate-number>+</div>
          <div class="numBoxT2">{{contList.numBox[contType][7]}}</div>
        </div>
      </div>
    </div>

    <div class="contBox">
      <div class="wow bounceInUp generalTitle mt100">{{contList.general2T1[contType]}}</div>
      <div class="wow bounceInUp generalTitle2 ">{{contList.general2T2[contType]}}</div>
      <div class="wow bounceInUp generalTitle2 mb60">{{contList.general2T3[contType]}}</div>
      <div class="dps">
        <div :class="['wow', 'bounceInUp', 'programme3Box', hoverType[3] == 1 ? 'programme3Box1' : '']" @mouseenter="handleMouseEnter('3')" @mouseleave="handleMouseLeave('3')">
          <div class="programme3IconBox">
            <img v-if="hoverType[3] == 0" class="programme3Icon" src="../assets/img/index/icon01.png" alt="">
            <img v-if="hoverType[3] == 1" class="programme3Icon" src="../assets/img/index/icon011.png" alt="">
          </div>
          <div class="programme3T1" :class="[hoverType[3] == 1 ? 'programme3T11' : '']">{{contList.programme3[contType][0]}}</div>
          <div class="programme3T2" :class="[hoverType[3] == 1 ? 'programme3T21' : '']">{{contList.programme3[contType][1]}}</div>
        </div>
        <div :class="['wow', 'bounceInUp', 'programme3Box', hoverType[4] == 1 ? 'programme3Box1' : '']" @mouseenter="handleMouseEnter('4')" @mouseleave="handleMouseLeave('4')">
          <div class="programme3IconBox">
            <img v-if="hoverType[4] == 0" class="programme3Icon" src="../assets/img/index/icon02.png" alt="">
            <img v-if="hoverType[4] == 1" class="programme3Icon" src="../assets/img/index/icon022.png" alt="">
          </div>
          <div class="programme3T1" :class="[hoverType[4] == 1 ? 'programme3T11' : '']">{{contList.programme3[contType][2]}}</div>
          <div class="programme3T2" :class="[hoverType[4] == 1 ? 'programme3T21' : '']">{{contList.programme3[contType][3]}}</div>
        </div>
        <div :class="['wow', 'bounceInUp', 'programme3Box', hoverType[5] == 1 ? 'programme3Box1' : '']" @mouseenter="handleMouseEnter('5')" @mouseleave="handleMouseLeave('5')">
          <div class="programme3IconBox">
            <img v-if="hoverType[5] == 0" class="programme3Icon" src="../assets/img/index/icon03.png" alt="">
            <img v-if="hoverType[5] == 1" class="programme3Icon" src="../assets/img/index/icon033.png" alt="">
          </div>
          <div class="programme3T1" :class="[hoverType[5] == 1 ? 'programme3T11' : '']">{{contList.programme3[contType][4]}}</div>
          <div class="programme3T2" :class="[hoverType[5] == 1 ? 'programme3T21' : '']">{{contList.programme3[contType][5]}}</div>
        </div>
      </div>
      <div class="dps">
        <div :class="['wow', 'bounceInUp', 'programme3Box', hoverType[6] == 1 ? 'programme3Box1' : '']" @mouseenter="handleMouseEnter('6')" @mouseleave="handleMouseLeave('6')">
          <div class="programme3IconBox">
            <img v-if="hoverType[6] == 0" class="programme3Icon" src="../assets/img/index/icon04.png" alt="">
            <img v-if="hoverType[6] == 1" class="programme3Icon" src="../assets/img/index/icon044.png" alt="">
          </div>
          <div class="programme3T1" :class="[hoverType[6] == 1 ? 'programme3T11' : '']">{{contList.programme3[contType][6]}}</div>
          <div class="programme3T2" :class="[hoverType[6] == 1 ? 'programme3T21' : '']">{{contList.programme3[contType][7]}}</div>
        </div>
        <div :class="['wow', 'bounceInUp', 'programme3Box', hoverType[7] == 1 ? 'programme3Box1' : '']" @mouseenter="handleMouseEnter('7')" @mouseleave="handleMouseLeave('7')">
          <div class="programme3IconBox">
            <img v-if="hoverType[7] == 0" class="programme3Icon" src="../assets/img/index/icon05.png" alt="">
            <img v-if="hoverType[7] == 1" class="programme3Icon" src="../assets/img/index/icon055.png" alt="">
          </div>
          <div class="programme3T1" :class="[hoverType[7] == 1 ? 'programme3T11' : '']">{{contList.programme3[contType][8]}}</div>
          <div class="programme3T2" :class="[hoverType[7] == 1 ? 'programme3T21' : '']">{{contList.programme3[contType][9]}}</div>
        </div>
        <div :class="['wow', 'bounceInUp', 'programme3Box', hoverType[8] == 1 ? 'programme3Box1' : '']" @mouseenter="handleMouseEnter('8')" @mouseleave="handleMouseLeave('8')">
          <div class="programme3IconBox">
            <img v-if="hoverType[8] == 0" class="programme3Icon" src="../assets/img/index/icon06.png" alt="">
            <img v-if="hoverType[8] == 1" class="programme3Icon" src="../assets/img/index/icon066.png" alt="">
          </div>
          <div class="programme3T1" :class="[hoverType[8] == 1 ? 'programme3T11' : '']">{{contList.programme3[contType][10]}}</div>
          <div class="programme3T2" :class="[hoverType[8] == 1 ? 'programme3T21' : '']">{{contList.programme3[contType][11]}}</div>
        </div>
      </div>
    </div>

    <div class="cooperation">
      <img class="cooperationBG2" src="../assets/img/index/cooperationBG2.png" alt="" data-wow-delay="0.1s">
      <img class="cooperationBG22" src="../assets/img/index/img02@2x(1).png" alt="" data-wow-delay="0.1s">
      <img class="wow bounceInUp logo1" src="../assets/img/index/logo-icon-1.png" alt="" data-wow-delay="0.2s">
      <img class="wow bounceInUp logo2" src="../assets/img/index/logo-icon-2.png" alt="" data-wow-delay="0.3s">
      <img class="wow bounceInUp logo3" src="../assets/img/index/logo-icon-3.png" alt="" data-wow-delay="0.4s">
      <img class="wow bounceInUp logo4" src="../assets/img/index/logo-icon-4.png" alt="" data-wow-delay="0.5s">
      <img class="wow bounceInUp logo5" src="../assets/img/index/logo-icon-5.png" alt="" data-wow-delay="0.6s">
      <img class="wow bounceInUp logo6" src="../assets/img/index/logo-icon-6.png" alt="" data-wow-delay="0.7s">
      <img class="wow bounceInUp logo7" src="../assets/img/index/logo-icon-7.png" alt="" data-wow-delay="0.8s">
      <img class="wow bounceInUp logo8" src="../assets/img/index/logo-icon-8.png" alt="" data-wow-delay="0.9s">
      <img class="wow bounceInUp logo9" src="../assets/img/index/logo-icon-9.png" alt="" data-wow-delay="1s">
      <img v-if="contType != 'e'" class="wow bounceInUp logo10" src="../assets/img/index/logo-icon-10.png" alt="" data-wow-delay="1.1s">
      <img v-if="contType == 'e'" class="wow bounceInUp logo10e" src="../assets/img/index/logo-icon-10e.png" alt="" data-wow-delay="1.1s">
      <img class="wow bounceInUp logo11" src="../assets/img/index/logo-icon-11.png" alt="" data-wow-delay="1.2s">
      <img class="wow bounceInUp logo12" src="../assets/img/index/logo-icon-12.png" alt="" data-wow-delay="1.3s">
      <div class="wow bounceInUp circular1"></div>
      <div class="wow bounceInUp circular2"></div>
      <div class="wow bounceInUp circular3"></div>
      <div class="wow bounceInUp circular4"></div>
      <div class="wow bounceInUp circular5"></div>
      <div class="wow bounceInUp cooperationzBox">{{contList.programme4[contType]}}</div>
    </div>
  </div>
</template>

<script>

import { WOW } from "wowjs";

export default {
  name: "index",
  data:vm=>{
    return {
      bodyW:0,
      bodyY:0,
      position:'',
      position2:'',
      contList: {
        title1:{
          z:'专注跨境收单',
          f:'專注跨境收單',
          e:'Focus on Cross-border Merchant Services'
        },
        title2:{
          z:'一站式金融服务',
          f:'一站式金融服務',
          e:' & One-stop Financial Services'
        },
        title3:{
          z:'为您提供专业化的跨境收单及全方位金融服务，企业跨境贸易的可靠选择。',
          f:'為您提供專業化的跨境收單及全方位金融服務，企業跨境貿易的可靠選擇。',
          e:'Suntone delivers professional cross-border merchant services and comprehensive financial services, which are reliable choice for enterprises developing business abroad.'
        },
        titleBtn:{
          z:'立即体验',
          f:'立即體驗',
          e:'Experience Now'
        },
        general1T1:{
          z:'跨境行业解决方案',
          f:'跨境行業解決方案',
          e:'Cross-border Industry Solutions'
        },
        general1T2:{
          z:'Suntone，为您提供全方位、专业化的跨境收付款服务,',
          f:'Suntone，為您提供全方位、專業化的跨境收付款服務',
          e:'Suntone, with our comprehensive and professional cross-border merchant services, '
        },
        general1T3:{
          z:'助力企业跨境出海，快速拓展国际市场！',
          f:'助力企業跨境出海，快進拓展國際市場！',
          e:'helps enterprises go abroad and edge in international market quickly!'
        },

        programmeB1T1:{
          z:'独立站一站式收单',
          f:'獨立站一站式收單',
          e:'One-stop Merchant Services'
        },
        programmeB1T2:{
          z:'支持VISA、MASTER、JCB等多种信用卡，覆盖全球；支持多种常见建站源码及平台，快捷接入，一站式服务。',
          f:'支持VISA、MASTER、JCB等多種信用卡，覆蓋全球；支持多種常見建站源碼及平台，快捷接入，一站式服務。',
          e:"Suntone supports credit card payment solution covering the world's leading card scheme like Visa, MasterCard, JCB, Discover, etc. We also support a variety of open-source package and plugins available for most e-commerce platform, which allow for easy integration into your business."
        },
        programmeB2T1:{
          z:'平台收款',
          f:'平台收款',
          e:'Platform Collection'
        },
        programmeB2T2:{
          z:'支持Shopee、Wish、eBay、Lazada等主流跨境电商平台的收款，解决海外开户难题，可以安全、高效、低成本地从全球各地收取多币种。',
          f:'支持Shopee、Wish、eBay、Lazada等主流跨域電商平台的收款，解決海外開戶難題，可以安全、高效、低成本地從全球各地收取多幣种。',
          e:'Suntone provide payment collection on Shopee, Wish, eBay, Lazada and other mainstream cross-border e-commerce platforms. Enjoy the safe，lower-cost and efficient payment experience with fast collection in multiple currencies around the world.'
        },
        programmeB3T1:{
          z:'覆盖行业',
          f:'覆蓋行業',
          e:'Industrial Coverage'
        },
        programmeB3T2:{
          z:'主要为跨境贸易、软件游戏、商贸旅行、教育培训等行业提供符合行业趋势的一站式跨境支付解决方案和服务。',
          f:'主要為跨境貿易、軟件遊戲、商貿旅行、教育培訓等行業提供符合行業趨勢的一站式跨境支付解決方案和服務。',
          e:'We support diversified payment scenarios (cross-border commerce, software gaming, business travel, education and training, etc.) and providing comprehensive and efficient cross-border payment solutions and services.'
        },
        programme2T:{
          z:['资金汇兑','随时随地结汇，支持多种币种的快捷兑换；官方银行渠道，安全透明。','电子钱包','支持多币种存取，官方安全认证，适用各种品类。','国际银行账户','极速开户，在线审批，支持SEPA直接转任何地方汇款。','预付卡虚拟卡','支持全球线上/线下消费，ATM服务，多币种账户，使用便捷，电子钱包助您随时随地管理您的资金。'],
          f:['資金匯兌','隨時隨地結匯，支持多種幣種的快捷兌換；官方銀行通路，安全透明。','電子錢包','支持多幣種存取，官方安全認證，適用各種品類。','國際銀行帳戶','極速開戶，線上審批，支持SEPA直接轉任何地方匯款。','預付卡虛擬卡','支持全球線上/線下消費，ATM服務，多幣種帳戶，使用便捷，電子錢包助您隨時隨地管理您的資金。'],
          e:['Exchange of Funds',
          'Suntone helps you make exchanges without time or distance limitations, supporting the exchange of a variety of currencies in as little as 3 minutes; official banking channels guarantee security and transparency.',
          'E-Wallet',
          'Our e-wallet supports multi-currency deposits/withdrawals and applicable to various categories.',
          'Opening Accounts with International Banks',
          'Enable fast account opening, online approval, supports SEPA,SWIFT transfer and easy remittance anywhere in the world.',
          'Prepaid Cards/Virtual Cards',
          'You can enjoy unlimited in-person or online purchasing power worldwide with a multi-currency card and withdraw money globally in local currencies to meet your cash needs. E-wallet is available to help you manage your funds anytime and anywhere.']
        },
        numBox:{
          z:['10年+','跨境支付服务经验','150+','国家与地区','20+','本地币种','2000+','商户选择'],
          f:['10年+','跨境支付服務經驗','150+','國家與地區','20+','本地幣種','2000+','商戶選擇'],
          e:['10','experiences in cross-border payment services','150+','countries and regions','20+','local currencies','2000+',"merchants' choices"],
        },
        general2T1:{
          z:'一站式收付解决方案',
          f:'一站式收付解決方案',
          e:'One-stop Payment Solutions'
        },
        general2T2:{
          z:'支持多币种，多国际主流信用卡支付方式',
          f:'支持多幣種，多國際主流信用卡支付方式',
          e:'Multi-currency, mainstream credit card payment methods supported easy access, free experience.'
        },
        general2T3:{
          z:'支持直连和跳转，轻松接入，体验自如',
          f:'支持直連和跳轉，輕鬆接入，體驗自如',
          e:''
        },
        programme3:{
          z:[
            '全球20+币种收款',
            '锁定中行实时汇率，透明无汇损',
            '7*24小时快速提款',
            'T+0提现时效，轻松优化资金周转',
            '支持国际信用卡及本地钱包',
            '支持VISA，MASTER，JCB等多种国际信用卡，支持多国本地钱包支付',
            '多平台支持',
            '支持Wordpress等多种建站源码，提供标准API接口，急速接入',
            '监管合规',
            '拥有境外多国支付牌照，资金合规无风险',
            '安全稳定',
            '专业的风控+大数据分析，为您的线上交易保驾护航'
          ],
          f:[
            '全球20+幣種收款',
            '鎖定中行實时匯率，透明無匯損',
            '7*24小時快速提款',
            'T+0提现时效，轻松优化资金周转',
            '支持国际信用卡及本地钱包',
            '支持VISA，MASTER，JCB等多種國際信用卡，支持多國本地錢包支付',
            '多平臺支持',
            '支持Wordpress等多種建站源碼，提供標準API介面，急速接入',
            '監管合規',
            '擁有境外多國支付牌照，資金合規無風險',
            '安全穩定',
            '專業的風控+大資料分析，為您的線上交易保駕護航'
          ],
          e:[
            'Global Collection in 20+ Currencies',
            "Lock real-time exchange rates of People's Bank of China, transparent transaction without loss of exchange.",
            '7*24h Fast Withdrawal',
            'T+0 withdrawal timeliness, easy to optimize turnover of capitals.',
            'Not only Credit Card',
            'We support credit card and wallet in single solution.',
            'Multi-Platform Support',
            'API intergration method is supported. We also offer open-sourse package and plugins available for most e-commerce platform, which allows you fast access to global payment solution.',
            'Regulatory Compliance',
            "With international payment license and PCI-DSS certification, Suntone's risk management system guarantees the safety of all funds.",
            'Safe and Steady',
            'With professional capability of risk control and big data analysis Suntone safeguards your online transaction.']
        },
        programme4:{
          z:'合作伙伴',
          f:'合作夥伴',
          e:'Partners'
        }
      },
      contType:'z',
      hoverType: {
        '0':0,
        "1":0,
        "2":0,
        "3":0,
        "4":0,
        "5":0,
        "6":0,
        "7":0,
        "8":0,
      }
    }
  },
  methods:{
    move(e){
      if(e.pageX>(this.bodyW/2)){
        this.position = 'right'
      }else {
        this.position = 'left'
      }
      if(e.pageY>425){
        this.position2 = 'top'
      }else {
        this.position2 = 'bottom'
      }
    },
    handleMouseEnter(item) {
      this.hoverType[item] = 1
    },
    // 移出
    handleMouseLeave(item) {
      this.hoverType[item] = 0
    },
    changeTypeTitleName() {
        if (this.contType == "f") {
          document.title = "首頁";
        }else if(this.contType == 'e'){
          document.title = 'Home'
        } else {
          document.title = "首页";
        }
    },
    goContactUs() {
      this.$router.push("/ContactUs");
    }
  },
  
  mounted() {
    this.bodyW = document.body.clientWidth;
    this.bodyY = document.body.clientHeight;
    var that = this;
    this.contType = window.localStorage.getItem('language');
    that.changeTypeTitleName()
    window.addEventListener('setItemEvent', function(e) {
      if (e.key == "language") {
        that.contType = e.newValue;
        that.changeTypeTitleName()
      }
    })
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 40,
      mobile: true,
      live: true
    })
    wow.init()
  }
};
</script>


<style src="../assets/css/index-pc.css"  scoped></style>
<style src="../assets/css/index-phone.css"  scoped></style>
<!-- <style lang="less" scoped>

@import '../assets/css/index-pc.css';
@import '../assets/css/index-phone.css';


</style> -->
